import { decluttifyABTestRouteConfig } from '@/config/abTestConfig'
import { navigateToNextOnboardingPage } from '@app-studio-web/ui/helpers/abTestRouting'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'

/**
 * Detect the variant from the URL path as a fallback when the Confidence SDK
 * is not configured (e.g. local development without VITE_CONFIDENCE_CLIENT_SECRET).
 * If the URL contains a known variant prefix like /v1/, use that variant.
 */
function detectVariantFromUrl(url: URL): string | null {
  const variantPrefixes: Record<string, string> = { v1: '/v1/' }
  for (const [variant, prefix] of Object.entries(variantPrefixes)) {
    if (url.pathname.includes(prefix)) {
      return variant
    }
  }
  return null
}

/**
 * Navigation action that supports A/B test variants
 * Uses the variant from React Context (managed by Confidence SDK),
 * with a URL-based fallback for local development without SDK.
 */
export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  // Get variant from context (stored globally during app initialization)
  let variant = getABTestVariantFromContext()

  // Fallback: detect variant from URL path when SDK isn't configured
  // This ensures /onboarding/v1/* pages use v1 route order even without
  // the Confidence SDK (e.g. local development, preview deployments)
  if (variant === 'baseline') {
    const url = new URL(request.url)
    const urlVariant = detectVariantFromUrl(url)
    if (urlVariant) {
      variant = urlVariant
    }
  }

  return navigateToNextOnboardingPage({
    request,
    routeConfig: decluttifyABTestRouteConfig,
    variant,
    redirectOnComplete: '/sign-up/company',
  })
}
